import algoliasearch from "algoliasearch/lite";

const algoliaClient = algoliasearch(
  window.algoliaApplicationId,
  window.algoliaSearchKey
);

const searchClient = {
  ...algoliaClient,
  search(requests) {
    return algoliaClient.search(requests);
  }
};

export default searchClient;
